import React, { useEffect, useState } from 'react';

const HEADLINE = 'AI that ships. Safely.';

const TypedHeadline: React.FC = () => {
  const [count, setCount] = useState(0);
  const done = count >= HEADLINE.length;

  useEffect(() => {
    if (done) return;
    const start = setTimeout(() => setCount((c) => c + 1), count === 0 ? 250 : 45);
    return () => clearTimeout(start);
  }, [count, done]);

  return (
    <h1
      aria-label={HEADLINE}
      className="relative text-5xl md:text-7xl font-semibold text-black leading-[1.05] tracking-[-0.035em] mb-8 max-w-4xl"
    >
      <span aria-hidden="true" className="invisible">{HEADLINE}</span>
      <span aria-hidden="true" className="absolute inset-0">
        {HEADLINE.slice(0, count)}
        <span
          className={`inline-block w-[2px] md:w-[3px] h-[0.85em] align-[-0.1em] bg-black ml-1 ${
            done ? 'animate-blink' : ''
          }`}
        />
      </span>
    </h1>
  );
};

const Hero: React.FC = () => {
  return (
    <section className="bg-white">
      <div className="container-max section-padding pt-28 md:pt-40 pb-12 md:pb-16">
        <p className="text-sm font-medium text-neutral-500 mb-4 tracking-wide uppercase">
          For operations teams in regulated industries
        </p>

        <TypedHeadline />

        <p className="text-lg md:text-xl text-neutral-600 max-w-2xl mb-10 leading-relaxed">
          Your AI demo worked, then it stalled. We build it properly on your data, make it safe for compliance, and keep it running.
        </p>

        <div className="flex flex-col sm:flex-row gap-3 mb-16">
          <a
            href="https://calendar.app.google/cnN9KoLp6WZYMX9G7"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center justify-center bg-black hover:bg-neutral-800 text-white text-base font-medium px-7 py-3.5 rounded-full transition-colors"
          >
            Book a free fit call
          </a>
          <a
            href="mailto:contact@zwiftlabs.com"
            className="inline-flex items-center justify-center bg-white text-black border border-neutral-200 hover:border-neutral-900 text-base font-medium px-7 py-3.5 rounded-full transition-colors"
          >
            Get in touch
          </a>
        </div>

        <div className="flex items-center gap-0 text-sm text-neutral-400">
          <span>Network ops</span>
          <span className="mx-4 h-4 w-px bg-neutral-200 inline-block" />
          <span>Financial crime</span>
          <span className="mx-4 h-4 w-px bg-neutral-200 inline-block" />
          <span>Patient access</span>
        </div>
      </div>
    </section>
  );
};

export default Hero;
